import create from "zustand";

export const useP2PContextStore = create((set, get) => ({
	ready: false,
	signaler: null,
	ice: null,
	channelName: null,
}));
